import React from 'react';

import * as SG from '../../constants/AppSettings'
import * as RT from '../../constants/Routing';
import { Helmet } from 'react-helmet'
import { Link } from 'react-router-dom';
import Card from '../Community/Card'
import LoadingGif from '../../lib/images/loading.gif'
export default class Component extends React.Component {

  handlePageMove(path) {
    this.props.history.push(path)
  }

  componentWillMount = () => {
    this.props.getCommunities()
  }

  render = () => {

    const metaInfo = (
      <Helmet>
        <title>{SG.META_TITLE}</title>
        <meta name='description' content={SG.META_DESCRIPTION} />
      </Helmet>
    )
    let head
    if (this.props.App.signInCheckResult) {
      head =  (
        <div className='top-catch'>
          <div className='back-overlay'>
            <div className='center-wrap'>
              <h2 className='catch-title'>家でも会社でもない好きで繋がる<br className='d-block d-lg-none' />第3のコミュニティ</h2>
            </div>
          </div>
        </div>
      )
    } else {
      head = (
        <div className='top-catch'>
          <div className='back-overlay'>
            <div className='center-wrap'>
              <h2 className='catch-title'>家でも会社でもない好きで繋がる<br className='d-block d-lg-none' />第3のコミュニティ</h2>
              <a href='https://info.circrew.fun/' target="_blank" className='btn btn-transparent'>circrew とは？</a>
              <Link to={RT.SIGN_UP_PATH} className='btn btn-primary'>サークルーに参加</Link>
            </div>
          </div>
        </div>
      )
    }


    let body
    if (!this.props.Home.loaded) {
      body = (
        <div className='col-12'>
          <img src={LoadingGif} alt='' className='loading-img' />
        </div>
      )
    } else {
      if (this.props.Home.communities.length > 0) {
        body = this.props.Home.communities.map(circle => {
          return (
            <Card circle={circle} key={circle.id} />
          )
        })
      } else {
        body = (
          <div className='col-xs-12'>公開されているコミュニティはありません。</div>
        )
      }
    }


    return (
      <div>
        {metaInfo}
        {head}
        {/* <nav className='search-tab'>
          <div className='container'>
            <ul className='row'>
              <li className='col-4'>
                <Link to='#' className='btn btn-default color-red'>カテゴリー</Link>
              </li>
              <li className='col-4'>
                <Link to='#' className='btn btn-default color-red'>エリア</Link>
              </li>
              <li className='col-4'>
                <Link to='#' className='btn btn-default color-red'>人気順</Link>
              </li>
            </ul>
          </div>
        </nav> */}
        <div className='border-bottom'></div>
        <div className='community-wrap container'>
          <div className='row'>
            {body}
          </div>
        </div>
      </div>
    )


  }
}


// WEBPACK FOOTER //
// ./src/components/Home/Home.jsx